/** Hook to access FocusContext with built-in provider validation. */
// @ts-check
import { useContext } from 'react';
import { FocusContext } from './FocusContextDef.js';

/**
 * @returns {{ activeFocusTaskId: string|null, focusStartTime: number|null, startFocus: (taskId: string) => void, stopFocus: () => void }}
 */
export const useFocus = () => {
  const context = useContext(FocusContext);
  if (!context) {
    throw new Error('useFocusContext must be used within a FocusProvider');
  }
  return context;
};

// Backward-compat alias
export const useFocusContext = useFocus;
